(function () {
  'use strict';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeProductionText(text) {
    const value = clean(text);
    if (!value) return value;
    if (/priority|expedit|7\s*business\s*days?|ship\s*within\s*7/i.test(value)) return value;
    if (/standard|production|lead\s*time|business\s*days?|weeks?/i.test(value)) {
      return 'Standard — Ships in 3–4 Weeks';
    }
    return value;
  }

  function polishConsolidatedBuilder(root) {
    const builder = root.querySelector('.daluca-custom-builder-live--consolidated');
    if (!builder) return;

    ['Keeper', 'Quick Release'].forEach(function (name) {
      const field = builder.querySelector('[data-daluca-proxy-field="' + name + '"]');
      if (!field) return;
      field.querySelectorAll('.daluca-proxy-choice').forEach(function (button) {
        button.removeAttribute('data-daluca-has-visual');
        button.removeAttribute('title');
      });
    });

    const production = builder.querySelector('[data-daluca-proxy-field="Production Time"]');
    if (production) {
      production.querySelectorAll('select option').forEach(function (option) {
        if (option.disabled || !clean(window.DaLucaI18n.sourceText(option))) return;
        const normalized = normalizeProductionText(window.DaLucaI18n.sourceText(option));
        if (normalized !== clean(window.DaLucaI18n.sourceText(option))) window.DaLucaI18n.setText(option, normalized);
      });
    }

    builder.querySelectorAll('.daluca-custom-summary__row').forEach(function (row) {
      const label = clean(row.querySelector('dt') && window.DaLucaI18n.sourceText(row.querySelector('dt')));
      const value = row.querySelector('dd');
      if (!value || !/production\s*time/i.test(label)) return;
      const normalized = normalizeProductionText(window.DaLucaI18n.sourceText(value));
      if (normalized !== clean(window.DaLucaI18n.sourceText(value))) window.DaLucaI18n.setText(value, normalized);
    });
  }

  function removeBrokenLegacyProcessArtifacts(root) {
    document.querySelectorAll('.daluca-custom-order-guide:not(.daluca-custom-order-guide--master)').forEach(function (node) {
      if (node.closest('.daluca-pdp--native-accessory')) return;
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
  }

  function run() {
    const root = document.querySelector('.daluca-pdp--custom');
    if (!root) return;
    polishConsolidatedBuilder(root);
    removeBrokenLegacyProcessArtifacts(root);
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      if (document.body) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    run();
    if (document.body) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', queue);
})();

